import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadPendingProductsForSomeoneElse = createAction(
  '[PendingProductsForSomeoneElse] Load PendingProductsForSomeoneElse',
  props<{ request: string }>()
);

export const loadPendingProductsForSomeoneElseSuccess = createAction(
  '[PendingProductsForSomeoneElse] Load PendingProductsForSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadPendingProductsForSomeoneElseFailure = createAction(
  '[PendingProductsForSomeoneElse] Load PendingProductsForSomeoneElse Failure',
  props<{ error: Error | any }>()
);
